import { FederatedPointerEvent, IDestroyOptions } from "pixi.js";
import { Button, ButtonOptions } from "./Button";

export class AnimatedButton extends Button<AnimatedButtonOptions> {
    public get isAnimationPlayed(): boolean {
        return this.isPointerUp && this.animationPlay;
    }

    private isPointerUp: boolean;
    private animationPlay: boolean;
    private currentTimeline: gsap.core.Timeline;
    private currentCallback: () => void;

    public constructor(options: AnimatedButtonOptions) {
        super(options);
        this.animationPlay = false;
        this.isPointerUp = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.options.pointerClickAnimation?.kill();
        this.options.pointerDownAnimation?.kill();
        this.options.pointerOutsideAnimation?.kill();
        this.options.pointerOutAnimation?.kill();
        this.options.pointerOverAnimation?.kill();
        super.destroy(options);
    }

    protected override handlePointerDown(e: FederatedPointerEvent): void {
        super.handlePointerDown(e);
        this.playAnimation(this.options.pointerDownAnimation);
    }

    protected override handlePointerUp(e: FederatedPointerEvent): void {
        if (this.isPointerUp) {
            return;
        }
        this.isPointerUp = true;
        super.handlePointerUp(e);
        this.playAnimation(this.options.pointerClickAnimation, () => {
            this.isPointerUp = false;
        });
    }

    protected override handlePointerUpOutside(e: FederatedPointerEvent): void {
        super.handlePointerUpOutside(e);
        this.playAnimation(this.options.pointerOutsideAnimation);
    }

    protected override handlePointerOut(e: FederatedPointerEvent): void {
        super.handlePointerOut(e);
        this.playAnimation(this.options.pointerOutAnimation);
    }

    protected override handlePointerOver(e: FederatedPointerEvent): void {
        this.playAnimation(this.options.pointerOverAnimation, () => super.handlePointerOver(e));
    }

    private async playAnimation(timeline: gsap.core.Timeline, callback?: () => void): Promise<void> {
        this.currentCallback?.();
        this.currentTimeline?.pause(0.0, true);
        this.currentCallback = callback;
        this.currentTimeline = timeline;
        if (timeline != null) {
            this.animationPlay = true;
            await this.currentTimeline.play();
        }
        this.animationPlay = false;
        this.currentCallback?.();
    }
}

export interface AnimatedButtonOptions extends ButtonOptions {
    pointerClickAnimation?: gsap.core.Timeline;
    pointerDownAnimation?: gsap.core.Timeline;
    pointerOutsideAnimation?: gsap.core.Timeline;
    pointerOutAnimation?: gsap.core.Timeline;
    pointerOverAnimation?: gsap.core.Timeline;
}